export const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1);
export const handleEnterPress = (callback) => (e) => {
    if (e.key === 'Enter') {
        e.stopPropagation();
        callback();
    }
};
